/* istanbul ignore next */ // Since this is just concatenating existing
import { validationSchema as eventSchema } from 'enter-cobra-qe/event-info/event-info.validators';
import { validationSchema as benefitsSchema } from 'enter-cobra-qe/benefits/cobra-benefits.validators';

export const validationSchema = eventSchema.concat(benefitsSchema);
/* istanbul ignore stop */
